import React, { useState } from 'react';
import { Map } from 'component/Map';
import { IMSMAID, IMSMAIDView } from './IMSMAID';
import { InternalId, InternalIdView } from './InternalId';
import { PolygonName, PolygonNameView } from './PolygonName';
import {
  DistrictViewWithoutSubId,
  LocalCommunityViewWithoutSubId,
  RegionViewWithoutSubId,
  SettlementViewWithoutSubId,
} from './Location';
import { Area } from './Area';
import { useBufferZone } from 'hooks/useBufferZone';
import { useHAReports } from 'hooks/useHAReports';
import { HASwitchers } from 'component/HASwitchers';

export const HABlock = ({ formData, setFormData, map, setMap }) => {
  useBufferZone(map);
  const haReportsHABlock = useHAReports(map);

  return (
    <div className="flex-column-group">
      <div className="flex-group gap-40">
        <IMSMAID formData={formData} setFormData={setFormData} />
        {formData && <DistrictViewWithoutSubId formData={formData} />}
      </div>
      <div className="flex-group gap-40">
        <InternalId formData={formData} setFormData={setFormData} />
        {formData && <LocalCommunityViewWithoutSubId formData={formData} />}
      </div>
      <div className="flex-group gap-40">
        <PolygonName formData={formData} setFormData={setFormData} />
        {formData && <SettlementViewWithoutSubId formData={formData} />}
      </div>
      <div className="flex-group gap-40">
        {formData && (
          <>
            <RegionViewWithoutSubId formData={formData} />
            <Area formData={formData} />
          </>
        )}
      </div>
      {formData && (
        <div style={{ position: 'relative' }}>
          <HASwitchers
            {...haReportsHABlock}
            googleWms={true}
            style={{
              position: 'absolute',
              top: '66px',
              zIndex: 1,
              background: 'rgba(255, 255, 255, 0.8)',
              borderRadius: '4px',
              padding: '0px 15px 7px 10px',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              left: '0px',
              borderRadius: '0 0 8px',
              boxShadow: '0px 20px 25px 0px rgba(76, 103, 100, 0.1)',
            }}
          />
          <Map
            map={map}
            setMap={setMap}
            turnPointsPolygon={formData?.info?.turn_points?.geojson}
            hazardAreaType={formData?.info?.general?.hazard_area_type}
            haReportsPolygons={haReportsHABlock?.haReportsPolygons}
            // azureLayerEnabled={haReportsHABlock?.azureLayerEnabled}
            // setAzureLayerEnabled={haReportsHABlock?.setAzureLayerEnabled}
            googleWms
          />
        </div>
      )}
    </div>
  );
};

export const HABlockView = ({ formData }) => {
  const [map, setMap] = useState(null);
  useBufferZone(map);
  const haReportsHABlockView = useHAReports(map);

  return (
    <div className="flex-column-group">
      <div className="flex-group gap-40 column-350">
        <IMSMAIDView formData={formData} />
        {formData && <DistrictViewWithoutSubId formData={formData} />}
      </div>
      <div className="flex-group gap-40 column-350">
        <InternalIdView formData={formData} />
        {formData && <LocalCommunityViewWithoutSubId formData={formData} />}
      </div>
      <div className="flex-group gap-40 column-350">
        <PolygonNameView formData={formData} />
        {formData && <SettlementViewWithoutSubId formData={formData} />}
      </div>
      <div className="flex-group gap-40 column-350">
        {formData && (
          <>
            <RegionViewWithoutSubId formData={formData} />
            <Area formData={formData} />
          </>
        )}
      </div>
      {formData && (
        <div style={{ position: 'relative' }}>
          <HASwitchers
            {...haReportsHABlockView}
            googleWms={true}
            style={{
              position: 'absolute',
              top: '66px',
              zIndex: 1,
              background: 'rgba(255, 255, 255, 0.8)',
              borderRadius: '4px',
              padding: '0px 15px 7px 10px',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              left: '0px',
              borderRadius: '0 0 8px',
              boxShadow: '0px 20px 25px 0px rgba(76, 103, 100, 0.1)',
            }}
          />
          <Map
            map={map}
            setMap={setMap}
            turnPointsPolygon={formData?.info?.turn_points?.geojson}
            hazardAreaType={formData?.info?.general?.hazard_area_type}
            haReportsPolygons={haReportsHABlockView?.haReportsPolygons}
            // azureLayerEnabled={haReportsHABlockView?.azureLayerEnabled}
            // setAzureLayerEnabled={haReportsHABlockView?.setAzureLayerEnabled}
            googleWms
          />
        </div>
      )}
    </div>
  );
};
